import { FILLING_LIST } from "@pdfking/filling-flex"
import { RecordByPrimaryKey } from "@pdfking/templates"

/** How a fill spends what the sheet has left over — filling-flex's modes. */
export const FillingList = RecordByPrimaryKey(FILLING_LIST)
